<template>
  <v-container>
    <v-row class="print-hide">
      <v-col cols="12">
        <v-row class="d-flex print-hide align-center">
          <v-breadcrumbs :items="breadcrumbs"> </v-breadcrumbs>
          <v-spacer></v-spacer>
          <div class="mx-auto px-6">
            {{ $todayDate() }}
          </div>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-alert
            color="primary"
            icon="mdi-information"
            border="left"
            elevation="0"
            text
        >Izvještaj se generira nakon što su sve ocjene zaključene za sve učenike
        </v-alert>
      </v-col>
    </v-row>
    <v-row class="print-show bel">
      <div style="display: flex; width: 100%;">
        <div><img class="print-show" width="100%" src="@/assets/img/plans_footer.png"/></div>
      </div>

    </v-row>
    <row class="print-show title">
      <h5 class="primary--text">Opći uspjeh učenika u vladanju - {{ selected_department ? selected_department.label : '' }}</h5>
    </row>
    <!--    <row class="print-show top-right">-->
    <!--      <span>Datum i vrijeme ispisa iz SUMIT eDnevnika: {{ $todayDate()  }} {{timestamp}} </span>-->
    <!--    </row>-->
    <row class="print-show title">
      <v-select
              class="print-hide"
              outlined
              :items="semesters"
              v-model="semesterNumber"
              item-text="label"
              item-value="value"
              @change="getDataFromApi"
              label="Polugodište"
      ></v-select>
    </row>
    <v-row>
      <v-col cols="12" md="3">
        <v-select
                outlined
                v-model="selected_field"
                :items="school.educational_fields"
                item-text="name"
                return-object
                color="primary"
                label="Odabir zanimanja"
                hide-details
                dense
                class="my-3 print-hide"
                @change="pickedFields"
                v-if="$checkPermission('profession picker')"

        ></v-select>
      </v-col>
      <!--      razrednik-->
      <v-col cols="12" md="3">
        <v-select
                outlined
                v-model="selected_year"
                :items="getYears"
                item-text="text"
                return-object
                color="primary"
                label="Odabir razreda"
                hide-details
                dense
                @change="pickedYear"
                class="my-3 print-hide"
                v-if="$checkPermission('class_year picker')"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" v-if="isHeadroomTeacher">
        <v-select
                outlined
                v-model="selected_department"
                :items="headroomDepartments"
                item-value="id"
                item-text="label"
                return-object
                color="primary"
                label="Odabir odjeljenja"
                hide-details
                dense
                class="my-3 print-hide"
                @change="getDataFromApi"
                v-if="$checkPermission('department picker')"

        ></v-select>
      </v-col>
      <v-col cols="12" md="3" v-else>
        <v-select
                outlined
                v-model="selected_department"
                :items="items_department"
                item-value="id"
                item-text="label"
                return-object
                color="primary"
                label="Odabir odjeljenja"
                hide-details
                dense
                class="my-3 print-hide"
                @change="getDataFromApi"
                v-if="$checkPermission('department picker')"

        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
            outlined
            :items="semesters"
            v-model="semesterNumber"
            item-text="label"
            item-value="value"
            hide-details
            dense
            class="my-3 print-hide"
            @change="getDataFromApi"
            label="Polugodište"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" class="print-hide text-right float-right">
        <v-btn width="170" @click="printPage" class="text-none" outlined color="primary">
          <v-icon left>mdi-printer</v-icon>
          Ispišite izvještaj
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
                :headers="headers"
                group-by="type"
                class="data_table1"
                dense
                :items="tableData"
                hide-default-footer
                :items-per-page="200"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
              <v-btn @click="toggle" x-small icon :ref="group">
                <v-icon v-if="isOpen" class="primary--text">mdi-minus</v-icon>
                <v-icon v-else class="primary--text">mdi-plus</v-icon>
              </v-btn>
              <span class="mx-5 font-weight-bold primary--text">{{ group }}</span>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <div class="print-show" >
        <v-row class="print-show" >
          <v-col class="print-show bottom-footer">
            <span>Centar za informacijske tehnologije Sveučilišta u Mostaru, SUMIT <br> A: Trg hrvatskih velikana 1, 88000 Mostar, BiH | E: sumit@sum.ba | W: https://sumit.sum.ba</span>
          </v-col>
        </v-row>

      </div>
    </v-row>
    <row class="print-show">
      <v-col class="print-show bottom-footer1">
      <span>Izvještaj je ispisan iz SUMIT eMatice: {{ $todayDate()  }} {{timestamp}} </span>
      </v-col>
    </row>
  </v-container>
</template>

<script>

  import ApiV2 from "@/services/ApiV2";

  export default {
    props: ['departmentId','semester'],
    name: "index",
    computed: {
      breadcrumbs() {
        return [
          {
            text: "Opći uspjeh učenika u vladanju",
            disabled: true,
            href: "/admin/izvjestaj/ucenici_vladanje",
          },
        ];
      },

      school() {
        return this.$store.getters.getSchool;
      },
      currentRole() {
        return this.$store.getters.getCurrentRole;
      },
      selectedField() {
        return this.$store.getters.getSchoolFieldId;
      },
      headroomDepartments() {
        return this.$store.getters.getCurrentRole?.schools.filter(x=>x.value == localStorage.getItem('school_id'))[0]?.headroom_departments;
      },
      isHeadroomTeacher() {
        return this.currentRole.role_id === 5;
      },
      getYears() {
        let children = [];

        if (this.$store.getters.getSchool.type === "Osnovna škola") {
          children = [
            {
              text: "1. razred",
              value: 1,
            },
            {
              text: "2. razred",
              value: 2,
            },
            {
              text: "3. razred",
              value: 3,
            },
            {
              text: "4. razred",
              value: 4,
            },
            {
              text: "5. razred",
              value: 5,
            },
            {
              text: "6. razred",
              value: 6,
            },
            {
              text: "7. razred",
              value: 7,
            },
            {
              text: "8. razred",
              value: 8,
            },
            {
              text: "9. razred",
              value: 9,
            },
          ];
        } else {
          children = [
            {
              text: "1. razred",
              value: 11,
            },
            {
              text: "2. razred",
              value: 12,
            },
            {
              text: "3. razred",
              value: 13,
            },
            {
              text: "4. razred",
              value: 14,
            },
          ];
        }
        return children;
      },
    },
    data: function () {
      return {
        reportData:{},
        drawer: null,
        stop: true,
        selected_field:null,
        selected_department: null,
        selected_year: null,
        school_class:null,
        items_department: [],
        activeRole: {
          model: -1,
          show: true,
          forceShow: false,
          data: [],
        },
        activeSchool: {
          model: {},
          label: "",
          data: [],
          show: true,
        },
        headers: [
          { text: "Tip", value: "type",
            align: 'left',
            class: "white--text primary",
          },
          { text: "Naziv", value: "label",
            align: 'left',
            class: "white--text primary",
          },
          { text: "Vrijednost", value: "value",
            align: 'right',
            class: "white--text primary",
          },
        ],
        tableData: [],
        semesterNumber: 1,
        semesters: [
          {
            label: '1. polugodište',
            value: 1
          },
          {
            label: '2. polugodište',
            value: 2
          },
          {
            label: 'Kraj školske godine',
            value: 0
          },
        ]
      };
    },
    mounted() {
      this.getDataFromApi();
    },
    methods: {
      printPage() {
        setTimeout(function() {
          window.print();
        }, 300);
      },
      getDataFromApi() {
        this.loading = true;
        ApiV2.get('reports/get_behavioral_success', {
          params: {
            semester_number: this.semesterNumber,
            department_id: this.selected_department.id,
          }
        }).then(response=>{
          this.tableData = response.data;
        })
      },
      async getDepartments() {
        let params = {
          filterRelation: {
            schoolEducationalField: {
              id: this.selected_field?.pivot.id,
            },
          },
          filter: {
            school_class: this.selected_year?.value,
          },
        };

        await ApiV2.get(`departments`, {
          params: params,
        }).then((response) => {
          this.items_department = response.data.data;
        });
      },
      pickedFields() {
        this.getDepartments();
      },
      pickedYear() {
        this.getDepartments();
      },

    },

  };
</script>

<!--<style lang="scss" scoped>-->
<!--  .color {-->
<!--    color: #084776;-->
<!--  }-->

<!--  @media print {-->
<!--    .fot{-->
<!--      position:fixed;-->
<!--      bottom:0;-->
<!--    }-->
<!--    .bel{-->
<!--      position:fixed;-->
<!--      top:0;-->
<!--    }-->
<!--    .title{-->
<!--      position:fixed;-->
<!--      top:200px;-->
<!--      text-align: center;-->
<!--    }-->
<!--    .data_table1 {-->

<!--      position:fixed;-->
<!--      top:230px;-->

<!--      tr {-->
<!--        display: block;-->
<!--        border-bottom: 1px solid black;-->
<!--        border-top: none;-->
<!--        border-right: none;-->
<!--        border-left: none;-->

<!--      }-->
<!--      td {-->
<!--        text-align: center;-->
<!--        height: 15px !important;-->
<!--        width: 1000px;-->
<!--        padding-left: 70px;-->
<!--        padding-top: 100px;-->
<!--        font-size: 12px !important;-->
<!--        border: none;-->
<!--      }-->

<!--      tr th:first-child {-->
<!--        width: 70% !important;-->
<!--      }-->

<!--      tr td:first-child {-->
<!--        width: 70% !important;-->
<!--      }-->

<!--      tr td:not(:first-child) {-->
<!--        width: 500px !important;-->
<!--      }-->

<!--      tr th:not(:first-child) {-->
<!--        width: 500px !important;-->
<!--      }-->
<!--    }-->


<!--    @page {-->
<!--      size: A4 !important;-->
<!--      display: none !important;-->
<!--      margin-left: 2cm !important;-->
<!--      margin-right: 1.5cm !important;-->
<!--      margin-bottom: 0.7cm !important;-->
<!--    }-->
<!--    .top-center {-->
<!--      padding-top: 10px;-->
<!--      font-size: 11px;-->
<!--      top: 12px;-->
<!--      text-align: center;-->
<!--      margin-bottom: 10px;-->

<!--    }-->
<!--    .bottom-footer {-->
<!--      font-size: 11px;-->
<!--      text-align: center;-->
<!--      position:fixed;-->
<!--      bottom:25px;-->

<!--    }-->
<!--    .bottom-footer1 {-->
<!--      font-size: 9px;-->
<!--      text-align: center;-->
<!--      position:fixed;-->
<!--      bottom:5px;-->

<!--    }-->

<!--    .top-right {-->
<!--      padding-top: 10px;-->
<!--      font-size: 11px;-->
<!--      top: 12px;-->
<!--      text-align: right;-->
<!--    }-->
<!--    .bottom-right {-->
<!--      font-size: 11px;-->
<!--      bottom: 3px;-->
<!--      position:fixed;-->
<!--      text-align: right;-->
<!--    }-->

<!--    .top-left {-->
<!--      padding-top: 10px;-->
<!--      font-size: 13px;-->
<!--      top: 12px;-->
<!--      text-align: left;-->
<!--    }-->
<!--  }-->
<!--</style>-->
